import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PlacesAutocompletePage } from './places-autocomplete.page';

const routes: Routes = [
  {
    path: '',
    component: PlacesAutocompletePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlacesAutocompletePageRoutingModule {}
